var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.681,
    height: 23.066,
    viewBox: "0 0 34.681 23.066",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30A2\\u30A4\\u30B3\\u30F3\\u306E\\u7121\\u6599\\u30D4\\u30AF\\u30C8\\u30B0\\u30E9\\u30E0",
    transform: "translate(0 -85.735)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1",
    "data-name": "\\u30D1\\u30B9 1",
    d: "M34.681,92.135a2.635,2.635,0,1,0-4.529,1.829c-1.792,3.711-5.217,5.005-7.871,3.832-2.364-1.045-3.237-4.034-3.532-6.349a3.03,3.03,0,1,0-2.817,0c-.3,2.316-1.168,5.3-3.532,6.349-2.654,1.173-6.078-.122-7.871-3.832a2.634,2.634,0,1,0-2.238.781L6.067,108.8H28.615l3.776-14.057A2.634,2.634,0,0,0,34.681,92.135Z",
    transform: "translate(0 0)",
    fill: "#efad40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.62185c5907fb01265e5d1ae581992f70.svg";
export { ForwardRef as ReactComponent };